<template>
  <div>
    <el-card class="box-card">
      <div class="warntitle">编辑(只能修改数量，如果需要新增或者删除产品，可以先使用删除订单功能，然后再重新创建订单。)</div>
      <el-form :model="editform" ref="editformRef" label-width="82px">
        <el-form-item v-for="(item,index) in editform.productList" label="" class="addAdminFormLongLong">
          <div class="productdata1">
            <div class="productdata2">
              产品名称:
              <el-input v-model="item.Name" placeholder="" style="width: 30%" disabled></el-input>
              单价:
              <el-input v-model="item.Money" placeholder="" style="width: 10%" disabled></el-input>
              数量:
              <el-button type="primary" @click="clickAddNum(item)">+</el-button>
              <el-input v-model="item.Num" placeholder="" style="width: 10%" disabled></el-input>
              <el-button type="primary" @click="clickSubNum(item)">-</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="总金额" class="addAdminForm">
          <el-input v-model="editform.moneytotal" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="收件姓名" class="addAdminForm">
          <el-input v-model="editform.recvname" placeholder="请输入收件人姓名"></el-input>
        </el-form-item>
        <el-form-item label="收件手机" class="addAdminForm">
          <el-input v-model="editform.phone" placeholder="请输入收件人手机"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" class="addAdminForm">
          <el-input v-model="editform.address" placeholder="请输入收件人地址"></el-input>
        </el-form-item>
        <el-form-item label="销售员" class="addAdminForm">
          <el-input v-model="editform.salesperson" placeholder="请输入销售员"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="editform.beizhu" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editform: {
        productList: [],
        moneytotal: '',
        recvname: '',
        phone: '',
        address: '',
        salesperson: '',
        beizhu: ''
      },
      orderid: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.orderid = parentdata.params.orderid
      this.editform.recvname = parentdata.params.recvname
      this.editform.phone = parentdata.params.phone
      this.editform.address = parentdata.params.address
      this.editform.salesperson = parentdata.params.salesperson
      this.editform.beizhu = parentdata.params.beizhu
      this.apiGetNaoxjStockSaleByOrderid()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditNaoxjStockSale()
    },
    clickAddNum (item) {
      item.Num += 1
      item.Moneytotal = item.Money * item.Num
      item.Moneytotal = +item.Moneytotal.toFixed(2)
      this.UpdateMoneytotalAndPaymentAccount()
    },
    clickSubNum (item) {
      if (item.Num <= 1) {
        Vue.prototype.FunAlertMsg('数量不能小于1')
      } else {
        item.Num -= 1
        item.Moneytotal = item.Money * item.Num
        item.Moneytotal = +item.Moneytotal.toFixed(2)
      }
      this.UpdateMoneytotalAndPaymentAccount()
    },
    UpdateMoneytotalAndPaymentAccount () {
      // 更新总价
      var Moneytotal = 0
      for (var k = 0, len = this.editform.productList.length; k < len; k++) {
        Moneytotal += this.editform.productList[k].Moneytotal
        Moneytotal = +Moneytotal.toFixed(2)
      }
      this.editform.moneytotal = Moneytotal
    },
    apiGetNaoxjStockSaleByOrderid: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSaleByOrderid, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.editform.productList = response.data.List
            that.UpdateMoneytotalAndPaymentAccount()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditNaoxjStockSale: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.orderid,
        productlist: JSON.stringify(that.editform.productList),
        moneytotal: that.editform.moneytotal,
        recvname: that.editform.recvname,
        phone: that.editform.phone,
        address: that.editform.address,
        salesperson: that.editform.salesperson,
        beizhu: that.editform.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditNaoxjStockSale, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}

.speed {
    width: 440px;
    margin-right: 15px;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(255, 0, 0);
}
</style>
